<template>
  <div :class="['itemprice', { 'inherit': inherit, 'is-sum': quantity > 1 }]">
    <b-row no-gutters :align-h="alignH">
      <b-col cols="auto">
        <i18n-n
          :value="activePrice.number * quantity"
          :format="{ key: 'currency', currency }"
          :class="['price-active']"
        >
          <template #currency="{ currency }"><span>{{ currency }}</span></template>
          <template #integer="{ integer }"><span class="integer">{{ integer }}</span></template>
          <template #group="{ group }"><span class="group">{{ group }}</span></template>
          <template #decimal="{ decimal }"><span class="decimal">{{ decimal }}</span></template>
          <template #fraction="{ fraction }"><span class="fraction">{{ fraction }}</span></template>
        </i18n-n>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ItemPrice',
  props: {
    productId: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    quantity: {
      type: Number,
      default: 1
    },
    alignH: {
      type: String,
      default: 'end',
      validator: value => ['start', 'center', 'around', 'between', 'end'].includes(value)
    },
    hideVatInfo: {
      type: Boolean,
      default: false
    },
    inherit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      priceData: this.createPrice(this.price)
    }
  },
  computed: {
    activePrice () {
      return this.priceData
    }
  },
  methods: {
    createPrice (value) {
      const number = Number(value)

      return {
        isValid: !isNaN(number) && number > 0,
        original: value,
        number: number,
        hideFraction: number % 1 === 0
      }
    }
  }
}
</script>

<style lang="scss">
$itemprice-active-font-size: 1.4em !default;
$itemprice-active-font-weight: $font-weight-bold !default;
$itemprice-active-color: $gray-700 !default;

$itemprice-active-currency-font-size: 0.777777em !default;
$itemprice-active-fraction-font-size: inherit !default;

$itemprice-active-promotional-color: $red !default;

$itemprice-original-gap: $spacer * 0.5 !default;
$itemprice-original-font-size: $itemprice-active-font-size !default;
$itemprice-original-font-weight: $itemprice-active-font-weight !default;
$itemprice-original-color: $itemprice-active-color !default;
$itemprice-original-linethrouth: $border-width solid $border-color !default;
$itemprice-original-linethrouth-glow: 0 1px 2px 0 rgba($itemprice-original-color, 0.85) !default;

$itemprice-original-currency-font-size: $itemprice-active-currency-font-size !default;
$itemprice-original-fraction-font-size: $itemprice-active-fraction-font-size !default;

$itemprice-vatinfo-font-size: $font-size-sm !default;
$itemprice-vatinfo-color: $gray-600 !default;

$itemprice-sum-font-weight: $font-weight-bold !default;

.itemprice {
  .price-active {
    display: block;
    font-size: $itemprice-active-font-size;
    font-weight: $itemprice-active-font-weight;
    color: $itemprice-active-color;

    .currency { font-size: $itemprice-active-currency-font-size; }
    .integer {}
    .group {}
    .decimal {}
    .fraction { font-size: $itemprice-active-fraction-font-size; }

    &.is-promotional {
      color: $itemprice-active-promotional-color;
    }
  }

  .price-original {
    display: block;
    position: relative;
    margin-left: $itemprice-original-gap;
    font-size: $itemprice-original-font-size;
    font-weight: $itemprice-original-font-weight;
    color: $itemprice-original-color;

    &:after {
      display: block;
      content: '';
      position: absolute;
      top: 52.5%;
      left: 0;
      right: 0;
      border-bottom: $itemprice-original-linethrouth;
      box-shadow: $itemprice-original-linethrouth-glow;
    }

    .currency { font-size: $itemprice-original-currency-font-size; }
    .integer {}
    .group {}
    .decimal {}
    .fraction { font-size: $itemprice-original-fraction-font-size; }
  }

  .hide-fraction {
    .decimal,
    .fraction {
      display: none;
    }
  }

  .price-vatinfo {
    font-size: $itemprice-vatinfo-font-size;
    color: $itemprice-vatinfo-color;
    text-align: right;

    a {
      color: inherit;
      text-decoration: none;
    }
  }

  &.inherit {
    .price-active,
    .price-original {
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
    }

    .price-active {
      &.is-promotional {
        color: $itemprice-active-promotional-color;
      }
    }
  }

  &.is-sum {
    .price-active,
    .price-original {
      font-weight: $itemprice-sum-font-weight;
    }
  }
}
</style>
